import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { furnitureService } from '@/services/FurnitureService'
import { furnitureKeys } from '@/hooks/queryKeys'
import type { FurnitureTagsDto } from '@lib/dto/furniture-tags.dto'

/** The tags a venue already uses, for suggesting as someone types. */
export function useFurnitureTags(venueId?: string | null): UseQueryResult<FurnitureTagsDto> {
  return useQuery({
    queryKey: [...furnitureKeys.all, 'tags', venueId ?? 'all'],
    queryFn: () => furnitureService.tags(venueId),
    staleTime: 60_000,
  })
}
